// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"20":"06c7d9cc","357":"a6620a37","417":"5a993183","508":"77611040","698":"fa9d84e8","745":"604c9ea4","856":"a8240f2e","951":"91192985"}[chunkId] + ".js";
};